module.exports = __webpack_public_path__ + "img/recurring-charges-icon.2f531a1a.svg";